import { useMutation, useQueryClient } from '@tanstack/react-query';
import { container } from '@/app/container';
import { UsersRepositoryToken } from '../../di/tokens';
import type { UpdateUserInput } from '../../domain/entities/user.entity';

export function useUpdateUser(userId: string) {
  const queryClient = useQueryClient();
  const repository = container.resolve(UsersRepositoryToken);
  return useMutation({
    mutationFn: (data: UpdateUserInput) => repository.updateUser(userId, data),
    onSuccess: () =>
      void queryClient.invalidateQueries({ queryKey: ['users', userId] }),
  });
}
